module.exports = __webpack_public_path__ + "56efce96f4e53741849483538a0511ec.svg";